import { render, staticRenderFns } from "./TemplateCategories.vue?vue&type=template&id=0b7fcec6"
import script from "./TemplateCategories.vue?vue&type=script&lang=ts"
export * from "./TemplateCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports